import { Stack } from "@mui/material";
import { ReviewCard } from "../Reviews/ReviewCard";
import ViewMoreList from "../ViewMoreList";
import { reviews } from "../../../constants/talent-profile";

export default function ReviewsList() {
  return (
    <ViewMoreList title="Reviews" onViewMore={() => {}} maxHeight="600px">
      <Stack direction="column" gap={2}>
        {reviews.map((_, index) => (
          <ReviewCard key={index} />
        ))}
      </Stack>
    </ViewMoreList>
  );
}
